import { useState } from "react";
import {
  Box,
  Container,
  IconButton,
  InputBase,
  Stack,
  Typography
} from "@mui/material";
import { EastRounded as SubmitIcon } from "@mui/icons-material";

import { Section } from ".";
import { observer, useStore } from "../../service/mobx";
import ButtonText from "../../component/Button/Text";
import { useRouter } from "next/navigation";

const Main = ({ setView }) => (
  <Section
    display="flex"
    flexDirection="column"
    minHeight="calc(100vh - 80px)"
    justifyContent="space-around"
  >
    <Container disableGutters my="auto" maxWidth="expanded">
      <Typography
        pb={{ compact: 3, expanded: 7 }}
        component="div"
        align="center"
        color="dark.surface.on.color"
        height="100%"
        sx={{
          textWrap: "balance",
          typography: { compact: "headlineLg", expanded: "displayLg" }
        }}
      >
        AI for AI builders
      </Typography>
      <Input />
      <Stack
        useFlexGap
        pt={{ compact: 10, expanded: 14 }}
        spacing={{ compact: 1, expanded: 5 }}
        direction="row"
        justifyContent="space-around"
        flexWrap={{ compact: "wrap", expanded: "nowrap" }}
      >
        {[
          "An Agent grounded in science for researchers",
          "Affordable AI models for developers"
        ].map((text, index) => (
          <Subheader
            key={text}
            text={text}
            onClick={() => setView(index + 1)}
          />
        ))}
      </Stack>
    </Container>
  </Section>
);
export default Main;
export const Input = observer(function Input() {
  const [input, setInput] = useState("");
  const { agent, bottomNav, device } = useStore();
  const route = useRouter();
  const submit = () => {
    agent.chat(input);
    route.push("/");

    if (device.isPhone) {
      bottomNav.actions[1].onClick();
    }
  };

  return (
    <Stack
      height={{ compact: 56, expanded: 72 }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={theme => ({
        pl: 3,
        pr: 2,
        py: 1,
        bgcolor: input
          ? "dark.secondary.container"
          : "dark.surface.container.highest",
        borderRadius: theme.shape.round,
        transition: theme.transitions.create("all")
      })}
    >
      <InputBase
        fullWidth
        value={input}
        placeholder="Ask Bytez a question about AI..."
        inputProps={{
          sx: {
            typography: { compact: "titleMd", expanded: "headlineSm" },
            color: "dark.surface.on.color"
          }
        }}
        onChange={event => setInput(event.target.value)}
        onKeyUp={event => {
          if (event.key === "Enter" && input) {
            submit();
          }
        }}
      />
      <IconButton
        disabled={input === ""}
        onClick={submit}
        sx={theme => ({
          bgcolor: "dark.secondary.color",
          color: "dark.secondary.on.color",
          transition: theme.transitions.create("all"),
          "&.Mui-disabled": {
            bgcolor: "dark.secondary.container"
          }
        })}
      >
        <SubmitIcon />
      </IconButton>
    </Stack>
  );
});
export const Subheader = ({ text, onClick, IconEnd }) => (
  <Box width="100%">
    <ButtonText
      label={text}
      onClick={onClick}
      IconEnd={IconEnd}
      sx={{
        width: "100%",
        height: "unset",
        p: 3,
        typography: {
          compact: "titleMd",
          expanded: "headlineSm"
        },
        textWrap: "balance",
        borderRadius: theme => theme.shape.md.round,
        color: "dark.surface.on.color",
        bgcolor: "dark.surface.container.low",
        "&:hover": {
          cursor: "pointer",
          color: "dark.secondary.on.container",
          bgcolor: "dark.secondary.container"
        }
      }}
    />
  </Box>
);
